var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin account connect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.292969,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#1F408C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 25.2916V19.4316C24.9999 16.5516 24.3799 14.3516 21.0199 14.3516C19.3999 14.3516 18.3199 15.2316 17.8799 16.0716H17.8399V14.6116H14.6599V25.2916H17.9799V19.9916C17.9799 18.5916 18.2399 17.2516 19.9599 17.2516C21.6599 17.2516 21.6799 18.8316 21.6799 20.0716V25.2716H24.9999V25.2916Z",
    fill: "#4987FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26056 14.6133H12.5806V25.2933H9.26056V14.6133Z",
    fill: "#4987FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9201 9.29297C9.86012 9.29297 9.00012 10.153 9.00012 11.213C9.00012 12.273 9.86012 13.153 10.9201 13.153C11.9801 13.153 12.8401 12.273 12.8401 11.213C12.8401 10.153 11.9801 9.29297 10.9201 9.29297Z",
    fill: "#4987FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedin.0364ae5c4635ac6ca3000b297cb04df9.svg";